import { MutationCache, QueryClient } from '@tanstack/react-query'

export const queryClient: QueryClient = new QueryClient({
  // Toute action locale (lecture d'un fil, paiement, affectation…) peut changer la cloche ou un badge : le résumé
  // des notifications est relu aussitôt plutôt qu'au prochain cycle de 60 s. Seules les requêtes affichées repartent.
  mutationCache: new MutationCache({
    onSettled: () => queryClient.invalidateQueries({ queryKey: ['notifications'] }),
  }),
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: true,
      retry: 1,
      staleTime: 30_000,
    },
    mutations: {
      retry: false,
    },
  },
})
